import { INTEGRATION_KEY } from "../../../state/integration/Constants"
import { BulkOperationStatus } from "./types"

export const BULK_OPERATION_TYPE = {
    CONTACT_UPDATE: "contacts-updates" as const,
    CREATE_ACCOUNT_STATEMENT: "account-statements-creation" as const,
    APPLY_INVOICE_PAYMENT: "apply-invoices-payments" as const,
    PRINT_INVOICE: "print-bulk-invoices" as const,
    APPLY_PRICE_LIST_PAYMENT: "apply-price-list-bulk-payment" as const,
    PRICE_LIST_CREATE_ORDER: "price-list-bulk-create-orders" as const,
    ORDER_STATUS_UPDATE: "orders-bulk-update-status" as const,
    DELETE: "bulk-delete" as const,
    EXPORT: "bulk-export" as const,
    SEND_EMAIL: "send-bulk-email" as const,
    EDIT_INVOICE_LOCATION: "bulk-edit-invoices-location" as const,
    EDIT_CREDIT_MEMO_LOCATION: "bulk-edit-credit-memos-location" as const
} as const

export const BULK_OPERATION_STATUS = {
    RUNNING: "running" as const,
    COLLECTING: "collecting" as const,
    COMPLETED: "completed" as const,
    CREATED: "created" as const,
    ERROR: "error" as const,
    ABORTED: "aborted" as const,
} as const

export const IN_PROGRESS_STATUSES: Array<BulkOperationStatus> = [
    BULK_OPERATION_STATUS.RUNNING,
    BULK_OPERATION_STATUS.COLLECTING,
    BULK_OPERATION_STATUS.CREATED,
]

export const COMPLETED_STATUSES: Array<BulkOperationStatus> = [
    BULK_OPERATION_STATUS.COMPLETED,
]

export const TERMINATED_STATUSES: Array<BulkOperationStatus> = [
    BULK_OPERATION_STATUS.ERROR,
    BULK_OPERATION_STATUS.ABORTED,
]

export const INTEGRATIONS_SUPPORTING_BULK_EXPORT = [INTEGRATION_KEY.MAILCHIMP]


// WEBPACK FOOTER //
// ./src/utils/automation/bulk/constants.ts